import React, { useState, useEffect } from "react";
import { Menu, X, Sun, Moon } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Footer from "../Components/Footer";
import ProjectSection from "./ProjectSection";
import Logo from "../Assets/Homeeframes/Homeeframes Liner (1).png";

const NaxosLandingPage = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const navigate = useNavigate();


  return (
    <div
      className={`min-h-screen w-full transition-colors duration-500 ${
        isDarkMode ? "bg-[#111111] text-white" : "bg-white text-black"
      }`}
    >

      {/* ───── HERO SECTION ───── */}
      <section className="min-h-screen flex flex-col items-center justify-center text-center px-6 pt-24 pb-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-4xl mx-auto flex flex-col items-center gap-6"
        >
          <h1
            className={`text-5xl md:text-7xl font-bold leading-tight tracking-tight ${
              isDarkMode ? "text-white" : "text-black"
           
            }`}
          >
<img src={Logo} alt="Homeeframes Logo" className="w-96 mx-auto mb-4" />
          </h1>

          <h1
            className={`text-5xl md:text-7xl font-bold leading-tight tracking-tight ${
              isDarkMode ? "text-white" : "text-black"
            }`}
          >
            Your vision deserves{" "}
            <span
              className={isDarkMode ? "text-[#FEF200]" : "text-gray-400"}
            >
              the right people.
            </span>
          </h1>

          <p
            className={`text-lg md:text-xl max-w-2xl leading-relaxed ${
              isDarkMode ? "text-gray-400" : "text-gray-500"
            }`}
          >
            Homeeframes enables seamless collaboration across the construction
            ecosystem, so you can dream big, connect smart, &amp; build better.
          </p>

          <div className="flex flex-wrap gap-4 justify-center mt-4">
            <a
              href="#projects"
              className={`px-8 py-3 rounded-full font-semibold text-sm tracking-wide transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg ${
                isDarkMode
                  ? "bg-[#FEF200] text-black hover:bg-yellow-300"
                  : "bg-black text-white hover:bg-gray-800"
              }`}
            >
              Explore Projects
            </a>
            <a
              href="/about"
              className={`px-8 py-3 rounded-full font-semibold text-sm tracking-wide border transition-all duration-300 hover:-translate-y-0.5 ${
                isDarkMode
                  ? "border-gray-600 text-white hover:border-white"
                  : "border-black text-black hover:bg-black hover:text-white"
              }`}
            >
              Learn More
            </a>
          </div>
        </motion.div>
      </section>

      {/* ───── PROJECTS SECTION ───── */}
      <div id="projects">
        <ProjectSection isDarkMode={isDarkMode} />
      </div>

      {/* ───── FOOTER ───── */}
      <Footer isDarkMode={isDarkMode} />
    </div>
  );
};

export default NaxosLandingPage;
